export enum Permission {
  UsersManage = 'users:manage',

  MatterAddUsers = 'matter:add-users',
  MatterDelete = 'matter:delete',
  MatterDeleteDocument = 'matter:delete-document',
  MatterManageUsers = 'matter:manage-users',
  MatterViewAll = 'matter:view-all',

  IntegrationsManage = 'integrations:manage',
  TokenLimitsManage = 'token-limits:manage',
  ApproveRuns = 'runs:approve',

  RealtimeUse = 'realtime:use',

  RelativityImport = 'relativity:import',

  UsageDashboardView = 'usage-dashboard:view',

  MatterCreateUpload = 'matter:create-upload',
}
